import React, {
  createContext,
  PropsWithChildren,
  use,
  useMemo,
  useRef,
  useState,
} from "react";

export const useTabsTab = () => {
  const context = use(TabsContext);
  const iRef = useRef<number>(null);
  const i = iRef.current ?? (iRef.current = context.counters.tab++);
  return useMemo(
    () => ({
      isActive: context.active === i,
      activate: () => context.activate(i),
    }),
    [context.active, i],
  );
};

export const useTabsContent = () => {
  const context = use(TabsContext);
  const iRef = useRef<number>(null);
  const i = iRef.current ?? (iRef.current = context.counters.content++);
  return useMemo(
    () => ({
      isActive: context.active === i,
    }),
    [context.active, i],
  );
};

const TabsContext = createContext<ReturnType<typeof useProvider>>(null);

export const TabsProvider = (p: PropsWithChildren<{}>) => {
  const value = useProvider();
  return <TabsContext value={value}>{p.children}</TabsContext>;
};

const useProvider = () => {
  const [active, setActive] = useState(0);
  const counters = useRef({
    tab: 0,
    content: 0,
  }).current;
  return useMemo(
    () => ({
      counters, //mutable for assigning indices to hook consumers
      active,
      activate: (i: number) => setActive(i),
    }),
    [active, counters],
  );
};
